module.exports = __webpack_public_path__ + "img/btn-circle-primary.0fff7f49.svg";